import secureLocalStorage from "react-secure-storage";

const useAuthentication = () => {
    const currentUser = JSON.parse(secureLocalStorage.getItem('currentUser'))
    return (currentUser && Object.keys(currentUser)?.length)
}

export default useAuthentication;